module.exports = __webpack_public_path__ + "img/swamp_well_small.173f82d9.png";